import { UnauthorizedError } from '@/services';
import { useLogout } from '@/hooks';

type Callback = (error: Error) => void;

export const useErrorHandler = (callback?: Callback) => (error: Error) => {
  const logout = useLogout();

  if (error instanceof UnauthorizedError) logout();
  else if (Boolean(callback)) callback(error);
};
